import React, { useEffect } from "react";
import "./index.css";
import Aos from "aos";
import Router from "./Components/Router";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { TransitionProvider } from "./context/TransitionContext";
import ParticleBackground from "./Components/ParticleBackground";

function App() {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <ThemeProvider>
      <BrowserRouter>
        <TransitionProvider>
          <ParticleBackground />
          <Router />
        </TransitionProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
